module.exports = __webpack_public_path__ + "img/iten3btn2.65cc5f6c.png";